import { render, staticRenderFns } from "./manage-match-list.vue?vue&type=template&id=56eb0e50&scoped=true&"
import script from "./manage-match-list.vue?vue&type=script&lang=js&"
export * from "./manage-match-list.vue?vue&type=script&lang=js&"
import style0 from "./manage-match-list.vue?vue&type=style&index=0&id=56eb0e50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb0e50",
  null
  
)

export default component.exports